import { Card, Colors, Container, Heading, Text, type IconName } from '@amelio/ui-library';

import { FeatureItem } from '@/components/FeatureItem/FeatureItem';
import { DocumentsIllustration } from '@/components/Illustrations/Illustration';
import { useAmelioTranslations } from '@/hooks';

interface SelectRevieweeHeaderProps {
    isSelfEvaluation: boolean;
}

export const SelectRevieweeHeader = ({ isSelfEvaluation }: SelectRevieweeHeaderProps) => {
    const { t } = useAmelioTranslations();
    const title = isSelfEvaluation
        ? t('evaluation360SelectReviewee.selfEvaluationHeaderCard.title')
        : t('evaluation360SelectReviewee.headerCard.title');

    const featureItems: { icon: IconName; heading: string; description: string }[] = [
        {
            icon: 'security-shield-tick',
            heading: isSelfEvaluation
                ? t(
                      'evaluation360SelectReviewee.selfEvaluationFeatureItem.developmentFocused.heading',
                  )
                : t('evaluation360SelectReviewee.featureItem.developmentFocused.heading'),
            description: isSelfEvaluation
                ? t(
                      'evaluation360SelectReviewee.selfEvaluationFeatureItem.developmentFocused.description',
                  )
                : t('evaluation360SelectReviewee.featureItem.developmentFocused.description'),
        },
        {
            icon: 'time-clock',
            heading: isSelfEvaluation
                ? t('evaluation360SelectReviewee.selfEvaluationFeatureItem.timeEstimate.heading')
                : t('evaluation360SelectReviewee.featureItem.timeEstimate.heading'),
            description: isSelfEvaluation
                ? t(
                      'evaluation360SelectReviewee.selfEvaluationFeatureItem.timeEstimate.description',
                  )
                : t('evaluation360SelectReviewee.featureItem.timeEstimate.description'),
        },
        {
            icon: 'business-status-up',
            heading: isSelfEvaluation
                ? t(
                      'evaluation360SelectReviewee.selfEvaluationFeatureItem.diversePerspectives.heading',
                  )
                : t('evaluation360SelectReviewee.featureItem.diversePerspectives.heading'),
            description: isSelfEvaluation
                ? t(
                      'evaluation360SelectReviewee.selfEvaluationFeatureItem.diversePerspectives.description',
                  )
                : t('evaluation360SelectReviewee.featureItem.diversePerspectives.description'),
        },
    ];
    return (
        <Card
            className={'flex flex-row py-10'}
            padding={'2xl'}
            borderRadius={'2xl'}
        >
            <Container
                gap={'sm'}
                direction={'col'}
                px={'sm'}
                className={'2xl:gap-md w-full 2xl:flex-row'}
            >
                <Card
                    className={'relative mx-2 flex flex-1 flex-col justify-center px-8'}
                    borderRadius={'2xl'}
                    borderColor={Colors.WHITE}
                >
                    <DocumentsIllustration
                        className={
                            'sm: absolute top-1/2 -left-15 !h-28 h-25 w-25 -translate-y-1/2 sm:!-left-20 sm:!w-35 lg:!h-40 xl:!-left-26 xl:!w-40'
                        }
                    />

                    <Heading
                        level={3}
                        weight={'medium'}
                        className={'leading-7'}
                    >
                        {title.split('\n').map((line, index) => {
                            return (
                                <span key={index}>
                                    {line}

                                    <br />
                                </span>
                            );
                        })}
                    </Heading>

                    <Text
                        className={'mt-4'}
                        size={'small'}
                    >
                        {isSelfEvaluation
                            ? t('evaluation360SelectReviewee.selfEvaluationHeaderCard.description')
                            : t('evaluation360SelectReviewee.headerCard.description')}
                    </Text>
                </Card>

                <Container
                    gap={'sm'}
                    direction={'col'}
                    className={'flex-2 justify-center'}
                >
                    {featureItems.map((item) => (
                        <FeatureItem
                            key={item.icon}
                            icon={item.icon}
                            heading={item.heading}
                            description={item.description}
                        />
                    ))}
                </Container>
            </Container>
        </Card>
    );
};
